// Toplu Ürün Resmi Yükle sihirbazı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.bulkImageAssign';

export const inventoryBulkImageAssignGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Ürün resimleri toplu nasıl yüklenir?'),
  intro: t(`${G}.intro`, 'Bu sihirbaz, bilgisayarınızdaki barkod adlı klasörlerde bulunan resimleri ilgili ürünlere topluca ekler. Her ürün için ayrı bir klasör olmalı ve klasörün adı ürünün barkodu olmalıdır.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Sihirbaz adımları'),
    body: t(`${G}.regions.body`, 'Adım içeriği'),
    footer: t(`${G}.regions.footer`, 'Devam / Gönder / Kapat'),
  },
  navItems: [
    t(`${G}.nav.select`, 'Klasör Seç'),
    t(`${G}.nav.preview`, 'Önizleme'),
    t(`${G}.nav.upload`, 'Yükle'),
  ],
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Klasörlerinizi hazırlayın'),
      text: t(`${G}.s1.text`, 'Bilgisayarınızda bir üst klasör açın ve içine her ürün için barkod adlı bir alt klasör koyun (ör. urun-resimleri → 8055…/, 8690…/). Resim dosyalarını barkod-1, barkod-2 gibi adlandırırsanız bu sırayla eklenir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Desteklenen biçimler: jpg, jpeg, png, webp, gif, bmp. Diğer dosyalar ve üst klasörün kendisindeki (alt klasörde olmayan) dosyalar alınmaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Üst klasörü seçin'),
      text: t(`${G}.s2.text`, '"Klasör Seç" adımında kesikli alana tıklayın ve barkod adlı alt klasörleri içeren ÜST klasörü seçin. Tarayıcı aynı anda birden fazla klasör seçtirmese de üst klasörü seçince hepsi birden gelir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tek bir barkod klasörü seçerseniz yalnız o eklenir ("Sadece 1 klasör geldi" uyarısı çıkar). Tekrar tıklayarak başka klasör de ekleyebilirsiniz; aynı barkod yeniden seçilirse eskisinin yerine geçer.'),
        t(`${G}.s2.tip2`, 'Gelen klasörler barkod (resim sayısı) olarak listelenir; çarpıyla tek klasörü, "Temizle" ile tümünü çıkarabilirsiniz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Barkod eşleşmesini başlatın'),
      text: t(`${G}.s3.text`, '"Devam"a basın. Sistem her klasör adını ürün barkodlarıyla karşılaştırır ve "Önizleme" adımına geçer.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Önizlemeyi kontrol edin'),
      text: t(`${G}.s4.text`, 'Üstte Eşleşen, Eşleşmeyen ve Seçili sayıları görünür. Tabloda her klasörün ilk resmi, barkodu, bulunan ürün, üründe mevcut resim sayısı ve eklenecek resim sayısı yer alır. Eşleşen satırlar seçili gelir; istemediklerinizin işaretini kaldırın.'),
      tips: [
        t(`${G}.s4.tip1`, 'Bulunamadı: bu barkodda ürün yok. Mükerrer: bu barkoda sahip birden fazla ürün var. Bu satırlar seçilemez.'),
        t(`${G}.s4.tip2`, '"Geri" ile klasör seçimine dönebilirsiniz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Yükleyin ve ürünlere atayın'),
      text: t(`${G}.s5.text`, '"Gönder (n)" seçili ürünlerin resimlerini yükler, resim kütüphanesinde barkod adlı bir klasöre kaydeder ve ürünlere ekler. Ürünün mevcut resimleri silinmez, yeniler yanına eklenir. İlerleme çubuğu bitene kadar pencere kapatılamaz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sonuçta kaç ürünün güncellendiği ve kaç resim eklendiği yazar. Tabloda her barkod için Yüklendi / Eklendi / Atlandı sayıları ve durum görünür; hata satırının üzerine gelince nedeni okunur.'),
        t(`${G}.s5.tip2`, 'Ürün başına en fazla 8 resim sınırı uygulanır; eklenemeyen resimler "Atlandı" sütununda sayılır.'),
      ],
    },
  ],
});
